var ajax = require('./sv-jedesheim.ajax.js');

function registerAuthEvents() {

	$(".c-btn-login,.c-btn-logout").click(function (e) {
		e.preventDefault();

		$('.authentication-failed').addClass('hide');

		ajax.ajaxCall($(this).parents('form').prop('action'), $(this).parents('form').prop('method'), $(this).parents('form').serialize(), function (data) {
			if (data === 'authentication failed') {
				$('.authentication-failed').removeClass('hide');
			} else {
				if (document.location.href === data['intended']) {
					location.reload();
				} else {
					document.location.href = data['intended'];
				}
			}
		});
	});
}

module.exports.registerAuthEvents = registerAuthEvents;
